import { Controller } from "@hotwired/stimulus";

export default class FlyoutMenuController extends Controller {
  static targets = [
    "trigger",
    "flyout",
    "mobileMenu",
    "mobileSubmenu",
    "mobileSubmenuIcon",
  ];
  static values = {
    showClass: { type: String, default: "flyout-visible" },
    hideClass: { type: String, default: "flyout-hidden" },
  };

  connect() {
    // Close flyout when clicking outside
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.handleClickOutside);

    // Get custom classes from data attributes if they exist
    if (this.hasFlyoutTarget) {
      const showClass = this.flyoutTarget.dataset.flyoutMenuShowClass;
      const hideClass = this.flyoutTarget.dataset.flyoutMenuHideClass;

      if (showClass) this.showClassValue = showClass;
      if (hideClass) this.hideClassValue = hideClass;

    }
  }

  disconnect() {

    document.removeEventListener("click", this.handleClickOutside);

  }

  // Hover handlers for desktop flyout
  showFlyout() {
    if (this.hasFlyoutTarget) {
      this.flyoutTarget.classList.remove(this.hideClassValue);
      this.flyoutTarget.classList.add(this.showClassValue);
      if (this.hasTriggerTarget) {
        this.triggerTarget.setAttribute("aria-expanded", "true");
      }
    }
  }

  hideFlyout() {
    if (this.hasFlyoutTarget) {
      this.flyoutTarget.classList.remove(this.showClassValue);
      this.flyoutTarget.classList.add(this.hideClassValue);
      if (this.hasTriggerTarget) {
        this.triggerTarget.setAttribute("aria-expanded", "false");
      }
    }
  }

  // Click handler (still works for accessibility)
  toggleFlyout(event) {
    event.stopPropagation();
    if (this.hasFlyoutTarget) {
      if (this.flyoutTarget.classList.contains(this.hideClassValue)) {
        this.showFlyout();
      } else {
        this.hideFlyout();
      }
    }
  }

  toggleMobileMenu(event) {
    event.stopPropagation();
    this.mobileMenuTarget.classList.toggle("hidden");
  }

  closeMobileMenu() {
    this.mobileMenuTarget.classList.add("hidden");
    // Also close submenu if open
    if (this.hasMobileSubmenuTarget) {
      this.mobileSubmenuTarget.classList.add("hidden");
      this.mobileSubmenuIconTarget.classList.remove("rotate-180");
    }
  }

  toggleMobileSubmenu(event) {
    event.stopPropagation();
    this.mobileSubmenuTarget.classList.toggle("hidden");
    this.mobileSubmenuIconTarget.classList.toggle("rotate-180");
  }

  handleClickOutside(event) {
    // Close flyout if clicking outside of it
    if (
      this.hasFlyoutTarget &&
      !this.flyoutTarget.classList.contains(this.hideClassValue)
    ) {
      if (!this.flyoutTarget.contains(event.target)) {
        this.hideFlyout();
      }
    }
  }
}
